import { cn } from "@/lib/utils";
import { Metadata } from "@/pages/Reporting/Report";

import { Block } from "./Block";
import { ContentData } from "./Report.utils";
import { TextContent } from "./TextContent";

export const Report = ({
  title,
  content,
  metadata,
  onUpdateContentList,
  onUpdateTitle,
}: {
  title: ContentData;
  content: ContentData[];
  metadata: Metadata;
  onUpdateContentList: (contents: ContentData[]) => void;
  onUpdateTitle: (contents: ContentData) => void;
}) => {
  return (
    <>
      <div id="Title" className={cn("fcol ml-3", "gap-4", "hover:bg-deepBg", "p-4", "rounded-md")}>
        <TextContent content={title} onContentUpdate={onUpdateTitle}></TextContent>
      </div>
      <div className="px-2">
        <Block metadata={metadata} onUpdateContent={onUpdateContentList} contents={content} />
      </div>
    </>
  );
};
